import { render, staticRenderFns } from "./SalesAging.vue?vue&type=template&id=746a51e7"
import script from "./SalesAging.vue?vue&type=script&lang=js"
export * from "./SalesAging.vue?vue&type=script&lang=js"
import style0 from "./SalesAging.vue?vue&type=style&index=0&id=746a51e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports